import { Action } from "redux";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { getMasterEligibilityPayer } from "../../../actions/Master";
import EligibilityCheck from "../components/EligibilityCheck";
import { checkEligibility, saveEligibilityInformation, saveReferralRequestor } from "../../../actions/ReferralRequest";
import { EligibilityInformation, EligibilityPayload } from "../../../models/CheckEligibility";
import { ReferralRequestor } from "../../../models/ReferralRequestor";

const mapStateToProps = ({ payerState, checkEligibilityState, eligibilityInformationState, referralRequestorState }: ApplicationState) => ({
    payerState,
    checkEligibilityData: checkEligibilityState,
    eligibilityInformation: eligibilityInformationState,
    ReferralRequestor: referralRequestorState.response,
});
const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, Action<any>>
) => {
    return {
        getMasterEligibilityPayer: () => {
            dispatch(getMasterEligibilityPayer());
        },
        checkEligibility: (payload: EligibilityPayload) => {
            dispatch(checkEligibility(payload));
        },
        saveEligibilityInformation: (sessionData: EligibilityInformation) => {
            dispatch(saveEligibilityInformation(sessionData));
        },
        saveReferralRequestor: (sessionData: ReferralRequestor) => {
            dispatch(saveReferralRequestor(sessionData));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(EligibilityCheck);